<!--
 * @Description: 指定岗位查看指定组织机构人员数据
 * @Autor: lwq 
 * @Date: 2020-08-15 14:17:17
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:25:29
 * @FilePath: \mrc-base-frontend\src\views\data-access-strategy\modules\viewDataOfDesignOrganizationalStructureAtDesignatedPositions\index.vue
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <!-- 头顶 -->
        <showDataAccessHeader
          @add="add"
          :showAdd="!readonly"
          :label="
            $t('label_View_the_personnel_data_of_the_designated_organization')
          "
          :readonly="readonly"
          v-model="
            dataobj.mrbase_sys_data_strategy_specified_post_toorg_is_used
          "
        />
        <!-- 中间内容 -->
        <dataCard
          v-for="(item, index) in list"
          class="mb-7"
          :index="index"
          :key="item.uuid"
          :list="item"
          :readonly="readonly"
          @edit="edit"
          @deleteItem="deleteItem"
        >
          <template #default="{ item }">
            <v-row>
              <v-col cols="12">
                <mrc_ess_autoComplete
                  :label="$t('label_Position_Title') + '*'"
                  :readonly="true"
                  multiple
                  positionView
                  v-model="item.post_uuid"
                  :prompt_name="company_post"
                >
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12">
                <mrc_ess_autoComplete
                  :label="$t('label_Viewed_organization') + '*'"
                  :readonly="true"
                  multiple
                  deptView
                  v-model="item.org_level_uuids"
                  :prompt_name="dept_uuid"
                ></mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12">
                <mrc_ess_staffInfo
                  v-model="item.exclude_staff_uuids"
                  defaultRequest
                  item-value="staff_id"
                  :label="$t('label_Exclude_people')"
                  :readonly="true"
                  :multiple="true"
                  filter="1,2,3,5"
                >
                </mrc_ess_staffInfo>
              </v-col>
              <v-col cols="12">
                <tree
                  v-model="item.exclude_function_uuids"
                  :readonly="true"
                ></tree>
              </v-col>
            </v-row>
          </template>
        </dataCard>
        <!-- 弹出框 -->
      </v-card-text>
      <!-- 指定岗位查看指定组织机构人员数据-->
      <dialogModule
        v-model="open"
        :title="
          $t('label_View_the_personnel_data_of_the_designated_organization')
        "
        :paramsData="currentItem"
        @getData="getData"
      />
      <mrc_ess_submitBtn
        @success="success"
        v-if="!readonly"
        :cancelText="
          $store.state.uuid ? $t('label_cancel') : $t('label_The_previous_step')
        "
        @cancel="cancel"
      >
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import showDataAccessHeader from "../showDataAccessHeader";
import dialogModule from "./dialogModule";
import dataCard from "../dataCard.vue";
import tree from "../tree";
import {
  listData,
  getData,
  updateData,
  addData,
  delData,
} from "@/service/api/data-access-strategy";
export default {
  components: { showDataAccessHeader, dialogModule, dataCard, tree },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skeletonloading: true,
      open: false,
      params: null,
      currentItem: {},
      currentIndex: null,
      dataobj: {
        mrbase_sys_data_strategy_specified_post_toorg_is_used: "0",
      },
      list: [],
      deleteList: [], //删除的每一项
    };
  },
  validations: {},
  computed: {
    job_post_uuid() {
      //岗位查询
      return {
        prompt_name: "job_post",
        org_level_uuid: this.$store.state.currentCompany,
      };
    },
    company_post() {
      return {
        prompt_name: "company_post",
        org_level_uuid: this.$store.state.currentCompany,
      };
    },
    dept_uuid() {
      return {
        prompt_name: "levelUuid_deptUuid",
        org_level_uuid: this.$store.state.currentCompany,
      };
    },
  },
  created() {},
  watch: {},
  async mounted() {
    if (this.$store.state.uuid) {
      //修改
      await this.getList();
    } else {
      //新增
    }
  },
  methods: {
    async getList() {
      if (this.$store.state.uuid) {
        this.skeletonloading = true;
        const res = await getData({
          org_level_uuid: this.$store.state.uuid,
          date: "mrbase_sys_data_strategy_specified_post_toorg",
        });
        if (res.code == 200) {
          this.list = res.mrbase_sys_data_strategy_specified_post_toorg
            ? res.mrbase_sys_data_strategy_specified_post_toorg
            : [];
          this.dataobj = res.data ? res.data : {};
          this.dataobj.mrbase_sys_data_strategy_specified_post_toorg_is_used
            ? ""
            : (this.dataobj.mrbase_sys_data_strategy_specified_post_toorg_is_used =
                "0");
        }
        this.skeletonloading = false;
      } else {
      }
    },
    add() {
      this.currentItem = Object.assign({});
      this.currentIndex = null;
      this.open = true;
    },
    getData(val, type) {
      // 0新增 1修改
      this.params = val;
      if (type == 1) {
        this.$set(
          this.list,
          this.currentIndex,
          Object.assign(this.currentItem, val)
        );
      } else {
        this.list.push(val);
      }
    },
    edit(item, index) {
      //修改
      this.currentItem = item;
      this.currentIndex = index;
      this.open = true;
    },
    deleteItem(item, index) {
      //删除
      this.currentItem = item;
      this.currentIndex = index;
      if (item.uuid) {
        this.deleteList.push({ ...item, type: "del" });
      }
      this.list.splice(index, 1);
    },
    async success() {
      if (this.$store.state.uuid) {
        //修改
        let arr = [...this.list, ...this.deleteList].map((item) => {
          return { ...item, strategy_uuid: this.dataobj.uuid };
        });
        const res = await updateData({
          mrbase_sys_data_strategy_specified_post_toorg_properties: "005", //指定岗位可以查看指定组织架构 策略uuid
          "~table~": "mrbase_sys_data_strategy_specified_post_toorg",
          org_level_uuid: this.$store.state.uuid,
          mrbase_sys_data_strategy_specified_post_toorg_is_used:
            this.dataobj.mrbase_sys_data_strategy_specified_post_toorg_is_used,
          mrbase_sys_data_strategy_specified_post_toorg: arr,
        });
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_modification_was_successful"),
          });
          await this.getList();
          this.$emit("updateSuccess");
        }
        // else {
        //   this.$Message({ text: this.$t(res.msg), color: 'rgba(0, 0, 0, 0.38)' })
        // }
      } else {
        //新增
        this.$emit("success");
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getList();
        this.$emit("updateSuccess");
      } else {
        this.$emit("cancel");
      }
    },
  },
};
</script>

<style scoped></style>
